// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* global styles */

/* @font-face {
  font-family: "Euclid Circular Regular";
  src: url("./fonts/EuclidCircularA-Regular-WebM.woff");
}
@font-face {
  font-family: "Euclid Circular Medium";
  src: url("./fonts/EuclidCircularA-Medium-WebM.woff");
}
@font-face {
  font-family: "Euclid Circular Bold";
  src: url("./fonts/EuclidCircularA-Bold-WebM.woff");
} */


* {
  font-family: 'Euclid Circular A';
}


/* color definitions */
:host {
  --warn: #eb6f4a;
  /*--warn: #dd7832;*/
  --warn-hover: #ff8866;
  --white: #fff;
  --grey: #ccc;
  --dark-grey: #22292f;
  --med-grey: #3D4852;
  --light-grey: #bbb;
  --lighter-grey: #ddd;
  --blue: #2e72b7;
  --red: #d00;

  --Colors-UI-Primary-Primary-Light: #D9ECFA;

  /* chart series color palette */
  --chart-1: #2e72b7;
  --chart-2: #eb6f4a;
  --chart-3: #50b86c;
  --chart-4: #9b59b6;
  --chart-5: #f5a623;
  --chart-6: #1abc9c;
}

/*
.edit-mode-only:not(.edit-mode-enabled) {
  display: none;
}
*/
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;;;;;;;;;;;GAWG;;;AAGH;EACE,gCAAgC;AAClC;;;AAGA,sBAAsB;AACtB;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,WAAW;;EAEX,0CAA0C;;EAE1C,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;CAIC","sourcesContent":["/* global styles */\n\n/* @font-face {\n  font-family: \"Euclid Circular Regular\";\n  src: url(\"./fonts/EuclidCircularA-Regular-WebM.woff\");\n}\n@font-face {\n  font-family: \"Euclid Circular Medium\";\n  src: url(\"./fonts/EuclidCircularA-Medium-WebM.woff\");\n}\n@font-face {\n  font-family: \"Euclid Circular Bold\";\n  src: url(\"./fonts/EuclidCircularA-Bold-WebM.woff\");\n} */\n\n\n* {\n  font-family: 'Euclid Circular A';\n}\n\n\n/* color definitions */\n:host {\n  --warn: #eb6f4a;\n  /*--warn: #dd7832;*/\n  --warn-hover: #ff8866;\n  --white: #fff;\n  --grey: #ccc;\n  --dark-grey: #22292f;\n  --med-grey: #3D4852;\n  --light-grey: #bbb;\n  --lighter-grey: #ddd;\n  --blue: #2e72b7;\n  --red: #d00;\n\n  --Colors-UI-Primary-Primary-Light: #D9ECFA;\n\n  /* chart series color palette */\n  --chart-1: #2e72b7;\n  --chart-2: #eb6f4a;\n  --chart-3: #50b86c;\n  --chart-4: #9b59b6;\n  --chart-5: #f5a623;\n  --chart-6: #1abc9c;\n}\n\n/*\n.edit-mode-only:not(.edit-mode-enabled) {\n  display: none;\n}\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
